import React, { useEffect, useState } from 'react';
import HelpBackIcon from './../../../../../images/helpbackicon.png'
import {Link, useNavigate} from 'react-router-dom'

function AccountSetup() { 
    const [feedback,setFeedback] = useState(false)
    const navigate= useNavigate()

    return (
        <div style={{backgroundImage:`url("https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/yovww6fxrbmtzfqlpy0z")`,backgroundPositionX:'-1em',backgroundSize:'100%'}}>

        <div style={{         
        display:'flex',
        flexDirection:'column',
        alignItems:'center',
        zIndex:'1',
        height:'9.63em'
        }}/>

        <div style={{
              backgroundColor:'#F9FCFF',
              width:'100%',
              display:'flex',
              flexDirection:'column',
              alignItems:'center',
              paddingBottom:'5.5em'
        }}>
            <div style={{
                display:'flex',
                flexDirection:'column',
                alignItems:'flex-start',
                width:'70%',
                paddingTop:'2.5em'
            }}>

                <div style={{
                    display:'flex',
                    flexDirection:'row',
                    alignItems:'center',
                    cursor:'pointer'
                   
                }} onClick={()=>{navigate("/help");setFeedback(false)}}>
                    <img src={HelpBackIcon} style={{width:'1.5em',height:'1.5em',marginRight:'0.25em',cursor:'pointer'}}/>
                    <div className="backTxt">Back</div>
                </div>

                <div className="infoHeader">
                    Account Setup
                </div>

                <div className="infoDesc"> 
                * Accessed in the settings tab
                 </div>

                 <div className="infoDescHeader">
                 STEP 1: ARTIST PROFILE 
                 </div>

                 <div className="infoDesc"> 
                 This is where you will create your internal dashboard. 
                 </div>

                 <div className="infoDesc"> 
                 &nbsp;&nbsp;&nbsp;&#x2022;&nbsp;&nbsp;&nbsp;Add your artist name
                 </div>
                 <div className="infoDesc"> 
                 &nbsp;&nbsp;&nbsp;&#x2022;&nbsp;&nbsp;&nbsp;Profile Picture
                 </div>
                 <div className="infoDesc"> 
                 &nbsp;&nbsp;&nbsp;&#x2022;&nbsp;&nbsp;&nbsp;Main Genre
                 </div>
                 <div className="infoDesc"> 
                 &nbsp;&nbsp;&nbsp;&#x2022;&nbsp;&nbsp;&nbsp;The city that you’re based out of
                 </div>

                 <div className="infoDescHeader">
                 STEP 2: BILLING
                 </div>
                 <div className="infoDesc"> 
                 This is where you’ll manage your platform subscription. This should be auto-populated upon setup, but it’s a good idea to familiarize yourself with it incase you plan to upgrade to higher tiers
                 </div>
                 <div className="infoDesc"> 
                 &nbsp;&nbsp;&nbsp;&#x2022;&nbsp;&nbsp;&nbsp;Credit Card Info
                 </div>
                 <div className="infoDesc"> 
                 &nbsp;&nbsp;&nbsp;&#x2022;&nbsp;&nbsp;&nbsp;Payment details: Name, billing address, etc
                 </div>

                 {/* <div className="infoDescHeader">
                 STEP 3: WALLET
                 </div>
                 <div className="infoDesc"> 
                 This is where you’ll access and manage your royalty payouts. It is a direct deposit directly to your bank
                 </div>
                 <div className="infoDesc"> 
                 &nbsp;&nbsp;&nbsp;&#x2022;&nbsp;&nbsp;&nbsp;Add your payment details: Name, billing address, etc
                 </div>
                 <div className="infoDesc"> 
                 &nbsp;&nbsp;&nbsp;&#x2022;&nbsp;&nbsp;&nbsp;Add your routing and bank account info for the account in which you would like the funds transferred to when available
                 </div>
                 <div className="infoDesc"> 
                 &nbsp;&nbsp;&nbsp;&#x2022;&nbsp;&nbsp;&nbsp;Account verification
                 </div> */}



                {
                    !feedback &&
                    <div>
                         <div className="infoDesc" style={{marginTop:'6.5em'}}>
                            Was this article helpful?
                            </div>

                            <div style={{display:'flex',flexDirection:'row'}}>
                                <div className="helpfulBtn" onClick={()=>setFeedback(true)}>
                                    YES
                                </div>

                                <div className="helpfulBtn" onClick={()=>setFeedback(true)}>
                                    NO
                                </div>
                            </div>
                    </div>
                }

                {
                    feedback &&
                    
                         <div className="infoDesc" style={{marginTop:'8.5em'}}>
                           Thank you for your feedback
                            </div>

                         
                    
                }
               
            </div>

        </div>
        
        
       
    </div>
    )
}


export default AccountSetup;